/**
 * Helper for backend `userLanguage` payloads.
 *
 * Returns the active store-tracked BCP-47 tag, which is seeded at bootstrap
 * from URL detection (`app.languages` → `lang` → browser → default) and is
 * subsequently overwritten by `/prepare` / setContextData only when no
 * URL-driven value is present.
 *
 * Callers must use this for every API payload that has a `userLanguage`
 * field — hardcoded `"en-US"` literals are forbidden so that partner-supplied
 * locale round-trips correctly through quote / validate / commit / etc.
 */
import { rampsStore } from "@/stores/ramps-store";

export function getActiveUserLanguageTag(): string {
	return rampsStore.state.lang || "en-US";
}
